export default __webpack_public_path__ + "static/media/ui-menu.142b7a54.png";